"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropList = exports.PageSize = void 0;
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var CloseThickIcon_1 = require("../../Icons/Assets/CloseThickIcon");
var SearchIcon_1 = require("../../Icons/Assets/SearchIcon");
var Localization_1 = require("../../Localization");
var Searcher_1 = require("../../Searcher");
var DropList_styles_1 = require("./DropList.styles");
exports.PageSize = 12;
exports.DropList = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.ConfirmCaption, ConfirmCaption = _b === void 0 ? Localization_1.strings.DropList_Action_Confirm : _b, _c = _a.HeaderCaption, HeaderCaption = _c === void 0 ? "" : _c, MaxHeight = _a.MaxHeight, NoItemsMessage = _a.NoItemsMessage, OnCloseMenu = _a.OnCloseMenu, OnConfirmClick = _a.OnConfirmClick, OnResetClick = _a.OnResetClick, OnSearch = _a.OnSearch, OnSearchCancel = _a.OnSearchCancel, OnSelectRelative = _a.OnSelectRelative, Placement = _a.Placement, _d = _a.PositionAbsolute, PositionAbsolute = _d === void 0 ? false : _d, _e = _a.ResetCaption, ResetCaption = _e === void 0 ? Localization_1.strings.DropList_Action_Reset : _e, SearchAriaLabel = _a.SearchAriaLabel, ShowConfirm = _a.ShowConfirm, ShowHeader = _a.ShowHeader, ShowReset = _a.ShowReset, ShowSearch = _a.ShowSearch, Style = _a.Style;
    var ulRef = React.createRef();
    var zIndex = Style ? Style.zIndex : 0;
    var searcher = Searcher_1.useSearcher(OnSearch, OnSearchCancel, { TriggerCancelOnEmptyString: true });
    var _f = React.useState(), replacer = _f[0], setReplacer = _f[1];
    var handleBackClicked = function (e) {
        e.stopPropagation();
        if (OnCloseMenu && !ShowConfirm) {
            OnCloseMenu();
        }
    };
    var handleOnKeyPressed = function (e) {
        e.stopPropagation();
        var target = e.target;
        if ((target.type !== "search" && keyboard.IsSpace(e))
            || keyboard.IsEnter(e)) {
            target.click();
        }
        else if (keyboard.IsDownArrow(e)) {
            moveToNextSibling(target);
        }
        else if (keyboard.IsUpArrow(e)) {
            moveToPrevSibling(target);
        }
        else if (keyboard.IsEscape(e) && OnCloseMenu) {
            OnCloseMenu();
        }
        else if (keyboard.IsLeftArrow(e) && OnCloseMenu) {
            OnCloseMenu();
        }
        else if (keyboard.IsRightArrow(e)) {
            if (target.attributes.getNamedItem("aria-haspopup") !== null &&
                target.attributes.getNamedItem("aria-haspopup").value === "true") {
                target.click();
            }
        }
    };
    var handleSearchOnKeyPressed = function (e) {
        e.stopPropagation();
        if (keyboard.IsUpArrow(e) && OnSelectRelative) {
            OnSelectRelative(-1);
        }
        else if (keyboard.IsDownArrow(e) && OnSelectRelative) {
            OnSelectRelative(1);
        }
        else if (keyboard.IsPageUp(e) && OnSelectRelative) {
            OnSelectRelative(-exports.PageSize);
        }
        else if (keyboard.IsPageDown(e) && OnSelectRelative) {
            OnSelectRelative(exports.PageSize);
        }
        else if (keyboard.IsEscape(e) && OnCloseMenu) {
            OnCloseMenu();
        }
        else {
            searcher.inputProps.onKeyUp(e);
        }
    };
    var moveToPrevSibling = function (target) {
        var newTarget = target.parentElement.previousSibling;
        if (newTarget) {
            var child = newTarget.firstChild;
            if (child.nodeName === "HR" || child.disabled) {
                moveToPrevSibling(child);
            }
            else {
                var setFocus = newTarget.firstChild;
                if (setFocus) {
                    setFocus.focus();
                }
            }
        }
    };
    var moveToNextSibling = function (target) {
        var newTarget = target.parentElement.nextSibling;
        if (newTarget) {
            var child = newTarget.firstChild;
            if (child.nodeName === "HR" || child.disabled) {
                moveToNextSibling(child);
            }
            else {
                var setFocus = newTarget.firstChild;
                if (setFocus) {
                    setFocus.focus();
                }
            }
        }
    };
    var handleConfirmClicked = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OnConfirmClick();
    };
    var handleResetClicked = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OnResetClick();
    };
    var handleSearchButtonClicked = function (e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (searcher.hasSearchValue) {
            searcher.triggerCancel();
        }
    };
    React.useEffect(function () {
        if (ShowSearch && searcher.inputProps.ref.current) {
            searcher.inputProps.ref.current.focus();
        }
        else {
            var firstItem = ulRef.current.querySelector("[tabindex='0']");
            if (firstItem) {
                firstItem.focus();
            }
            else {
                firstItem = ulRef.current.querySelector("[tabindex='-1']");
                if (firstItem) {
                    firstItem.focus();
                }
            }
        }
    }, []);
    return (Boolean(replacer) ? replacer :
        React.createElement(React.Fragment, null,
            React.createElement(DropList_styles_1.ClickWrapper, { style: { zIndex: zIndex }, onClick: handleBackClicked }),
            React.createElement("div", { onClick: handleBackClicked, ref: ref, style: Style, "data-placement": Placement },
                React.createElement(DropList_styles_1.ListWrapperDiv, { PositionAbsolute: PositionAbsolute, ShowConfirm: ShowConfirm, ShowHeader: ShowHeader, ShowReset: ShowReset, ShowSearch: ShowSearch },
                    ShowHeader && (React.createElement(DropList_styles_1.HeaderWrapper, null,
                        React.createElement(DropList_styles_1.Header, null, HeaderCaption))),
                    ShowSearch && (React.createElement(DropList_styles_1.SearchWrapperDiv, null,
                        React.createElement(DropList_styles_1.SearchInput, __assign({ onClick: function (e) { return e.stopPropagation(); }, "aria-label": SearchAriaLabel, placeholder: Localization_1.strings.Searcher_Label_Search }, searcher.inputProps, { onKeyUp: handleSearchOnKeyPressed })),
                        React.createElement(DropList_styles_1.SearchButton, { "aria-label": Localization_1.strings.Searcher_Label_ClearSearch, disabled: !searcher.hasSearchValue, onClick: handleSearchButtonClicked }, searcher.hasSearchValue ? React.createElement(CloseThickIcon_1.CloseThickIcon, null) : React.createElement(SearchIcon_1.SearchIcon, null)))),
                    React.Children.count(children) > 0
                        ? React.createElement(DropList_styles_1.UL, { MaxHeight: MaxHeight, onKeyDown: handleOnKeyPressed, ref: ulRef, role: "menu" }, React.Children.map(children, function (child) { return !Boolean(child) ? child : React.cloneElement(child, {
                            OnCloseMenu: OnCloseMenu,
                            SetReplacer: setReplacer,
                            Style: Style,
                        }); }))
                        :
                            React.createElement(React.Fragment, null, NoItemsMessage && React.createElement(DropList_styles_1.NoItemsP, null, NoItemsMessage)),
                    ShowConfirm && (React.createElement(DropList_styles_1.ConfirmButton, { onClick: handleConfirmClicked, type: "button" }, ConfirmCaption)),
                    ShowReset && (React.createElement(DropList_styles_1.ResetButton, { onClick: handleResetClicked, type: "button" }, ResetCaption))))));
});
